import { PawPrint, Heart } from "./Doodles";
import { Mail, Instagram } from "lucide-react";

const Footer = ({ onNavigate }) => (
  <footer data-testid="site-footer" className="border-t-2 border-[#16294B] bg-[#16294B] py-14" aria-label="Site footer">
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 px-5 text-center sm:px-8">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-[#FBF3E3] bg-[#3B82F6]">
          <PawPrint className="h-5 w-5" color="#FBF3E3" />
        </span>
        <span className="font-display text-3xl tracking-wide text-[#FBF3E3]">PROJECT ARCHIE</span>
      </div>

      <p className="flex items-center gap-2 font-display text-xl text-[#FBF3E3]/90">
        "Built with care. Driven by compassion." <Heart className="h-5 w-5" />
      </p>

      <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" aria-label="Footer navigation">
        {[
          { label: "Mission", href: "#mission" },
          { label: "Story", href: "#story" },
          { label: "Team", href: "#team" },
          { label: "Donate", href: "#donate" },
          { label: "Get Involved", href: "#join" },
        ].map((l) => (
          <button
            key={l.href}
            data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            onClick={() => onNavigate(l.href)}
            className="text-xs font-bold uppercase tracking-[0.25em] text-[#FBF3E3]/70 transition-colors hover:text-[#E63946]"
          >
            {l.label}
          </button>
        ))}
      </nav>

      <div className="flex flex-wrap items-center justify-center gap-4">
        <a
          data-testid="footer-email-link"
          href="mailto:projectarchiee@gmail.com"
          className="btn-press flex items-center gap-2.5 rounded-full border-2 border-[#FBF3E3] bg-transparent px-6 py-2.5 text-sm font-bold tracking-wide text-[#FBF3E3] shadow-[4px_4px_0_0_#FBF3E3] hover:bg-[#E63946] hover:border-[#E63946]"
        >
          <Mail className="h-4 w-4" aria-hidden="true" />
          projectarchiee@gmail.com
        </a>
        <a
          data-testid="footer-instagram-link"
          href="https://www.instagram.com/project.archie/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-press flex items-center gap-2.5 rounded-full border-2 border-[#FBF3E3] bg-transparent px-6 py-2.5 text-sm font-bold tracking-wide text-[#FBF3E3] shadow-[4px_4px_0_0_#FBF3E3] hover:bg-[#3B82F6] hover:border-[#3B82F6]"
        >
          <Instagram className="h-4 w-4" aria-hidden="true" />
          Project.archie
        </a>
      </div>

      <p className="text-xs text-[#FBF3E3]/50">
        Inspired by Archie the Cavapoo. Built for shelter dogs. A student-led community service initiative.
      </p>
    </div>
  </footer>
);

export default Footer;
